import { useServices } from "@core/servicesContext";
import { AsyncResult, useStoredData } from "@utils/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Track } from "./track";

export function useTrack(id: string): AsyncResult<Track> {
	const { trackService } = useServices();
	const currentProfile = useCurrentProfile();

	return useStoredData(id, trackService.trackStore, [currentProfile?.id]);
}
